import React from 'react'
import { useOutletContext } from 'react-router-dom'

import { DataGridPremium as DataGrid } from '@mui/x-data-grid-premium'
import { Box } from '@mui/material'
import { darken, lighten, styled } from '@mui/material/styles';

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getSelectedBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .super-app-theme--success': {
    backgroundColor: getBackgroundColor(
      theme.palette.success.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--header': {
    backgroundColor: 'lightgrey'
  },
}));

export default function List() {
  const [slides, activeSlide, validatedSlide, diagnosesValues, validateSlide, previousSlide, nextSlide, goToSlide, goToResultList] = useOutletContext()

  const [pageSize, setPageSize] = React.useState(10)
  
  const columns_label = [
    {
      field: 'id',
      headerName: '',
      minWidth: 50,
      flex: 1,
      sortable: false,
      renderCell: (props) => (
        <span style={{ color: 'grey' }}>{'Lame ' + props.row.id}</span>
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'diagnosis',
      headerName: 'Votre diagnostic',
      minWidth: 50,
      flex: 1,
      sortable: false,
      renderCell: (props) => (
        <div>
          <span>{diagnosesValues[props.row.id-1]}</span>
        </div>
      ),
      renderHeader: () => (
        <div style={{ fontWeight: 'bold' }}>
          {'Votre diagnostic'}
        </div>
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'visiocyt',
      headerName: 'VisioCyt ® Bladder',
      minWidth: 50,
      flex: 1,
      sortable: false,
      renderHeader: () => (
        <div style={{ fontWeight: 'bold' }}>
          {'VisioCyt ® Bladder'}
        </div>
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'endoscopie',
      headerName: 'Endoscopie',
      minWidth: 50,
      flex: 1,
      sortable: false,
      renderHeader: () => (
        <div style={{ fontWeight: 'bold' }}>
          {'Endoscopie'}
        </div>
      ),
      headerClassName: 'super-app-theme--header',
    },
  ]

  const handleRowClick = (params, event, details) => {
    goToSlide(params.row.id)
  }

  function CustomFooterStatusComponent(props) {
    return (
      <Box sx={{ p: 1, display: 'flex' }}>
        <b>{'Votre score: ' + slides.filter(slide => are_visiocyts_equals(slide.visiocyt, diagnosis_to_visiocyt(diagnosesValues[slide.id-1]))).length + '/' + slides.length}</b>
      </Box>
    );
  }

  function diagnosis_to_visiocyt(diagnosis) {
    let returnValue = "Positif"
    if (diagnosis === "C1" || diagnosis === "C2" || diagnosis === "C3") {
      returnValue = "Négatif"
    }
    return returnValue
  }

  function are_visiocyts_equals(v1, v2) {
    return v1.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') === v2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  return (
    <div>
      <Box marginBottom='1vh'
        sx={{
          height: '90vh',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
      }}>
        <div style={{ maxHeight: '50%', width: '60%' }}>
          <h1>Résultats</h1>
          <StyledDataGrid
            stickyHeader
            columns={columns_label} 
            rows={slides}
            pageSize={pageSize}
            onPageSizeChange={(newPage) => setPageSize(newPage)}
            rowsPerPageOptions={[10, 20, 30, 50]}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            disableRowSelectionOnClick
            onRowClick={handleRowClick}
            getRowClassName={(params) => `super-app-theme--${are_visiocyts_equals(params.row.visiocyt, diagnosis_to_visiocyt(diagnosesValues[params.row.id-1]))&& 'success'}`}
            autoHeight
            slots={{
              footer: CustomFooterStatusComponent,
            }}
          />
        </div>
      </Box>
    </div>
  )
}